import gsap from 'gsap';
import {Quad , Back} from 'gsap';
import React from 'react';
import { fixNumber } from '../../utils/utils';
import { BetType } from './Enums';
// import aboveIcon from '../../assets/images/above-icon.svg'
// import belowIcon from '../../assets/images/bellow-icon.svg'
import bitcoinIcon from '../../assets/images/bitcoin-icon.svg'
import { LiveMenuState } from './LiveRound';
import {getAboveIcon, getBellowIcon, liveMenuDescriptionHeight , liveRoundMenuCloseHeight} from '../../utils/constants'
import App from '../../App';

import '../../scss/bet-confirmation.scss'
import '../../scss/button.scss'
import { enterContest } from '../../services/Contest';
import { LoadingButton } from '../LoadingButton';


interface BetConfirmationProp{
    stack:number;
    betOdd:number;
    betType:BetType;
    isMobile:boolean,
    onBetConfirmationHandler : (show:boolean, toast: boolean, contestEntry: any) => void
    onBetConfirmationCloseComplete : () => void
    openContest:any
    btcPrice: number,
    auth: any
}


export enum BetConfirmationState{
    confirmed,
    waiting,
}
class BetConfirmation extends React.Component<BetConfirmationProp>{

    state               = {betState:BetConfirmationState.waiting, loading: false}
    btConfirm           = React.createRef<HTMLDivElement>();
    btCancel            = React.createRef<HTMLDivElement>();
    nextRoundTitle      = React.createRef<HTMLDivElement>();
    betConfirmationCard  = React.createRef<HTMLDivElement>();

    componentDidMount = ()=>{

        // if(!this.props.isMobile){
        //     this.betConfirmationCard.current.style.background = this.props.betType === BetType.closeAbove ? App.getPropertyFromStyle('--primary-color') : App.getPropertyFromStyle('--secondary-color')
        // }

        const div = document.getElementById('bet-confirmation');
        gsap.to(div , {
            duration:0,
            opacity:0
        });
        gsap.to(div , {
            duration:1,
            opacity:1
        })
        .delay(0.1);

        this.showNextRoundTitle(false , 0);
    }

    onEnterContest = async () => {
        const {id, contestType } = this.props.openContest
        const response = await enterContest({
            contestId: id,
            userId: this.props.auth.userId,
            contestType,
            direction: this.props.betType === BetType.closeAbove ? 'moon' : 'rekt' ,
            wager: this.props.stack,
            token: this.props.auth.token
        })
        return response
    }

    onConfirmHandler = async (confirm : boolean)=>{

        if(this.state.betState === BetConfirmationState.confirmed)
            return;

        if (confirm) {
            this.setState({loading: true})
            const response:any = await this.onEnterContest()
            if (response) {
                this.setState({betState:BetConfirmationState.confirmed});
                this.props.onBetConfirmationHandler(true, false, response.contestEntry);
            } else {
                this.setState({betState:BetConfirmationState.waiting});
                this.props.onBetConfirmationHandler(false, true, null);
            }

        } else {
            this.setState({betState:BetConfirmationState.waiting});
            this.props.onBetConfirmationHandler(false, false, null);
        }
            
        this.showNextRoundTitle(true);
        this.setState({loading: false})
    }

    lowerContent = (liveMenuState : LiveMenuState)=>{
        const div = document.getElementById('bet-confirmation');

        
        gsap.to(div , {
            duration:0.3,
            marginTop:liveMenuState === LiveMenuState.open ? 
            `${liveMenuDescriptionHeight + liveRoundMenuCloseHeight}px` : 
            `${liveRoundMenuCloseHeight}px`,
            ease:Quad.easeOut,
        })

        gsap.to(this.btCancel.current , {
            duration:0.2,
            alpha:0,
        })

        gsap.to(this.btConfirm.current , {
            duration:0.2,
            alpha:0,
        })

    }

    flipCard = ()=>{
        
        gsap.to(this.betConfirmationCard.current , {rotationY:360 , duration:1 , ease:Back.easeOut});
        gsap.to(this.btCancel.current , {
            duration:0.2,
            alpha:0,
        })

        gsap.to(this.btConfirm.current , {
            duration:0.2,
            alpha:0,
        })

    }

    fullyClose = ()=>{
        const div = document.getElementById('bet-confirmation');
        gsap.to(div , {
            duration:0.3,
            opacity:0,
            onComplete:()=>{this.props.onBetConfirmationCloseComplete()}
        });
        this.showNextRoundTitle(false);
    }

    showNextRoundTitle = (show : boolean , time : number = 0.5)=>{
        gsap.to(this.nextRoundTitle.current , {
            duration:time,
            opacity:show ? 1 : 0,
        })
    
    }

    render(){
        const bgColor = !this.props.isMobile ? this.props.betType === BetType.closeAbove ? App.getPropertyFromStyle('--primary-color') : App.getPropertyFromStyle('--secondary-color') : null
        const icon = this.props.betType === BetType.closeAbove  ? getAboveIcon(App.getPropertyFromStyle(('--buttons-font-color'))) : getBellowIcon(App.getPropertyFromStyle(('--buttons-font-color'))); 
        return (
            <div id="bet-confirmation" className={this.props.isMobile ? "bet-confirmation" : "bet-confirmation-desktop"}>
                <div ref={this.betConfirmationCard} className='bet-confirmation-card' style={{background: bgColor}}>
                <h1 className="header">{this.state.betState === BetConfirmationState.waiting  ?"Confirm your Bet" : "Bet Confirmed!" }</h1>
                <div className="confirmation-card">
                    <div className="card-header">
                        <div className='card-header-icon'>
                        {icon}
                        </div>
                        <p>{this.props.betType === BetType.closeAbove ? "Close Above" : "Close Below"}</p>
                    </div>
                    <div  className="card-content">
                        <p>{
                            this.props.betType === BetType.closeAbove ? "Bitcoin will close above the locked price at the end of the next game round." : 
                            "Bitcoin will close below the locked price at the end of the next game round."}
                        </p>
                        <div className="card-value">
                            <h2>{fixNumber(this.props.btcPrice)}</h2>
                            <img className='bet-confirmation-bitcoin-icon' src={bitcoinIcon} alt="bitcoin icon"></img>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="card-data-left">
                            <p>Your Stake</p>
                            <p className="card-data-bold">{`$${this.props.stack}`}</p>
                        </div>
                        <div className="card-data-right">
                            <p>Estimated Odds</p>
                            <p className="card-data-bold">{`${this.props.betOdd}x`}</p>
                        </div>
                    </div>
                </div>
                <p ref={this.nextRoundTitle} className="next-round-title">Next round starts in</p>
                <div className="footer">
                    <p ref={this.btCancel} onClick={()=>{this.onConfirmHandler(false)}}>Cancel</p>
                    <p></p>
                    <LoadingButton loading={this.state.loading}>
                        <p ref={this.btConfirm} onClick={()=>{this.onConfirmHandler(true)}}>Confirm</p>
                    </LoadingButton>
                </div>
                </div>
            </div>
        )
    }
  
}

export default BetConfirmation;
